import { Button, Typography } from "@mui/material";
import React from "react";

const CustomButton = ({
  isLoading,
  buttonType,
  isDisabled,
  onClick,
  leadingIcon,
  trailingIcon,
  IconSvg,
  iconStyling,
  extraButtonStyle,
  buttonVariant,
  isFullWidth,
  borderRadius,
  buttonText,
  isSelected,
  typoVariant,
  typoClass,
  keyProp,
  buttonSpace,
  colorVariant,
  buttonClassName,
}) => {
  const extraClassName = () => {
    if (buttonVariant == "primary") {
      return "mozPrimaryButton";
    }
    if (buttonVariant == "secondary") {
      return "mozSecondaryButton";
    }
    return "";
  };
  const buttonColorVariant = () => {
    if (colorVariant == "primary") {
      return "mozPrimaryColorButton";
    }
    if (colorVariant == "secondary") {
      return "mozSecondaryColorButton";
    }
    if (colorVariant == "third") {
      return "mozTertiaryColorButton";
    }
    return "";
  };
  const buttonBorderRadius = () => {
    if (borderRadius == "primary") {
      return "mozPrimaryBorderRadius";
    }
    if (borderRadius == "secondary") {
      return "mozSecondaryBorderRadius";
    }
    if (borderRadius == "third") {
      return "mozThirdBorderRadius";
    }
    return "";
  };
  const buttonPaddingSpace = () => {
    if (buttonSpace == "primary") {
      return "mozPrimaryButtonSpace";
    }
    if (buttonSpace == "secondary") {
      return "mozSecondaryButtonSpace";
    }
    return "";
  };
  return (
    <Button
      disabled={isDisabled}
      key={keyProp}
      sx={{ ...extraButtonStyle }}
      className={`mozButton ${extraClassName()} ${buttonBorderRadius()} ${
        isFullWidth == true ? "mozButtonFullWidth" : ""
      } ${
        isSelected == true ? "mozButtonSelected" : ""
      } ${buttonPaddingSpace()} ${buttonColorVariant()} ${buttonClassName}`}
      onClick={onClick}
      type={buttonType}
    >
      {leadingIcon === true && <IconSvg style={{ ...iconStyling }} />}
      <Typography variant={typoVariant} className={typoClass}>
        {buttonText}
      </Typography>
      {trailingIcon === true && <IconSvg style={{ ...iconStyling }} />}
    </Button>
  );
};

export default CustomButton;

CustomButton.defaultProps = {
  buttonVariant: "primary",
  borderRadius: "primary",
  isDisabled: false,
  isLoading: false,
  isFullWidth: false,
  isSelected: false,
  typographyVariant: "sSize",
  typoClass: "",
};
